/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    strong: "strong",
    em: "em"
  }, _provideComponents(), props.components), {Text} = _components;
  if (!Text) _missingMdxReference("Text", true);
  return React.createElement(Text, null, React.createElement(_components.p, null, "OpenStreetMap in Zambia now has ", React.createElement(_components.a, {
    href: "https://www.openstreetmap.org/#map=15/-9.3180/28.7429",
    rel: "nofollow noopener noreferrer"
  }, "260,000 more buildings"), ". We have now completed a massive building import for northern Zambia. Building data in OSM enables on the ground teams access to a critical shared resource and this new data is supporting active malaria prevention programs across Zambia."), React.createElement(_components.p, null, "Over the last few weeks, we’ve been working with ", React.createElement(_components.a, {
    href: "http://akros.com/",
    rel: "nofollow noopener noreferrer"
  }, "Akros Global Health"), ", ", React.createElement(_components.a, {
    href: "https://ona.io/home/",
    rel: "nofollow noopener noreferrer"
  }, "Ona"), ", and ", React.createElement(_components.a, {
    href: "https://www.usaid.gov/",
    rel: "nofollow noopener noreferrer"
  }, "USAID’s Geocenter"), " to import this massive building dataset. Akros has collected over a million buildings through mSpray, their Indoor Residual Spraying (IRS) program for malaria prevention funded by the ", React.createElement(_components.a, {
    href: "http://www.pmi.gov/",
    rel: "nofollow noopener noreferrer"
  }, "President’s Malaria Initiative (PMI)"), " and ", React.createElement(_components.a, {
    href: "https://www.usaid.gov/who-we-are/organization/bureaus/bureau-global-health",
    rel: "nofollow noopener noreferrer"
  }, "Bureau for Global Health"), " at USAID. These teams need data to know where, when and what to spray. Using geospatial data enables teams to more effectively carry out spray campaigns and offer real-time monitoring of spray team logs ensuring goals are being met. This import is just the beginning for these programs as they look to leverage OSM as a shared resource for baseline data.\n", React.createElement(_components.a, {
    href: "https://a.tiles.mapbox.com/v4/devseed.o68pfcp6/attribution,zoompan.html?access_token=pk.eyJ1IjoiZGV2c2VlZCIsImEiOiJnUi1mbkVvIn0.018aLhX0Mb0tdtaT2QNe2Q",
    rel: "nofollow noopener noreferrer"
  }, React.createElement(_components.strong, null, "Zambia Buildings Import"), "\n", React.createElement(_components.em, null, "Development Seed blog post"), "a.tiles.mapbox.com")), React.createElement(_components.p, null, "This new data comes just in time for ", React.createElement(_components.a, {
    href: "http://osmgeoweek.org/",
    rel: "nofollow noopener noreferrer"
  }, "OSM Geography Awareness Week"), ". If you’re in Lusaka, join the ", React.createElement(_components.a, {
    href: "http://osmgeoweek.org/event/lusaka-zam/",
    rel: "nofollow noopener noreferrer"
  }, "local OSM Zambia community for a mapathon"), ". Mapping events are happening around the globe this week to celebrate OSM. ", React.createElement(_components.a, {
    href: "http://osmgeoweek.org/events/",
    rel: "nofollow noopener noreferrer"
  }, "Find an event nearby"), " and join in the celebration."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
